<template>
  <div
    v-if="cycle.count_modules == 0 || !cycle.started"
    class="d-flex align-items-center justify-content-end cycle-modules"
  >
    <ModuleInfoPlaceholder
      v-for="m in cycle.total_modules"
      :key="m"
      :cycle="cycle"
      :module-order="m"
      class="ml-1 ml-sm-2"
    />
  </div>
  <div
    v-else
    class="d-flex align-items-center justify-content-end  cycle-modules"
  >
    <div
      v-for="m in cycle.modules"
      :key="m.id"
      class="d-flex"
    >
      <ModuleInfo
        :cycle="cycle"
        :module="m"
        class="ml-1 ml-sm-2"
      />
    </div>
    <ModuleInfoPlaceholder
      v-for="m of count_left_modules"
      v-if="count_left_modules > 0"
      :key="m"
      :cycle="cycle"
      :module-order="m + cycle.modules.length"
      class="ml-1 ml-sm-2"
    />
  </div>
</template>
<script>
import ModuleInfo from './ModuleInfo.vue';
import ModuleInfoPlaceholder from './ModuleInfoPlaceholder.vue';

export default {
    components: { ModuleInfo, ModuleInfoPlaceholder },
    props:{
        cycle: {
            required: true,
            type: Object,
        }
    },
    computed: {
      count_left_modules(){
        let left = this.cycle.total_modules - this.cycle.modules.length
       return  left < 0 ? 0 : left
      }
    }
}
</script>
<style scoped>
.cycle-modules{
  width: 184px;
}
</style>
